// extracted by mini-css-extract-plugin
module.exports = {"root":"CustomButton_root___glip","ribbon":"CustomButton_ribbon__JNwqX"};